<template>
  <div class="test"></div>
</template>

<script>
export default {
  methods: {
    listen() {
      var w = document.documentElement.clientWidth;
      if (w > 500) {
        // this.$router.replace('mobileLogin')
        location.reload();
      }
    },
  },
  created() {
    window.addEventListener("resize", this.listen);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.listen);
  },
};
</script>

<style lang="scss" scoped>
.test {
  width: 100%;
  height: 100%;
  background: none;
  // background-size: 100% 100%;
  position: absolute;
}
</style>
